import React from 'react';
import { TourGuideParagraph } from '../TourGuideParagaph';

export const Segment11 = () => (
    <TourGuideParagraph>
        <p>As you travel inwards, THE PEARL™ will be a trusted guide, confidant and muse to support and illuminate your unconscious mind. </p>
        <p>“If you want to go fast, go alone. If you want to go far, go together”.</p>
        <p>Ancient Proverb. Off we go - Together!</p>
    </TourGuideParagraph>
);